function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import qt from "./auth-manager.js";
import t from "../common/base-provider.js";
import ro from "../util/browser-detector.js";
import Ot from "./device-manager.js";
import DeviceProperties from "../Core/device-properties.js";
import { isArray as z, keys as C, validateValueIsFromEnum as ta, values as Rt } from "../util/code-utils.js";
import Pt from "./network-manager.js";
import Lt from "../request-controller.js";
import Mt from "./server-config-manager.js";
import Wt from "./session-manager.js";
import ne, { STORAGE_KEYS as s } from "./storage-manager.js";
import Bt from "./storage-manager-factory.js";
import u from "./subscription-manager.js";
import { TriggersProviderFactory as ot } from "../triggers/triggers-provider-factory.js";
import kt from "../User/user-manager.js";
import { User } from "../User/index.js";
import { parseQueryStringKeyValues as ll } from "../util/url-utils.js";
import { WindowUtils as no } from "../util/window-utils.js";
import { BRAZE_MUST_BE_INITIALIZED_ERROR as p } from "../common/constants.js";
import { SupportedOptions as zt, logger as N } from "../../shared-lib/index.js";
import _t from "../models/identifier.js";
var w = {
  Yo: "allowCrawlerActivity",
  Zo: "baseUrl",
  Wh: "noCookies",
  Vh: "devicePropertyAllowlist",
  Da: "disablePushTokenMaintenance",
  $h: "enableLogging",
  Yh: "enableSdkAuthentication",
  Ca: "manageServiceWorkerExternally",
  Xh: "minimumIntervalBetweenTriggerActionsInSeconds",
  Zh: "sessionTimeoutInSeconds",
  Qh: "appVersion",
  Ea: "appVersionNumber",
  _a: "serviceWorkerLocation",
  Ba: "safariWebsitePushId",
  Zn: "localization",
  er: "contentSecurityNonce",
  re: "allowUserSuppliedJavascript",
  Go: "inAppMessageZIndex",
  Ko: "openInAppMessagesInNewTab",
  tn: "openCardsInNewTab",
  en: "openNewsFeedCardsInNewTab",
  mh: "requireExplicitInAppMessageDismissal",
  Ia: "doNotLoadFontAwesome",
  Na: "deviceId",
  Aa: "serviceWorkerScope",
  Oa: "sdkFlavor"
};

var Vt = /*#__PURE__*/function () {
  function Vt() {
    _classCallCheck(this, Vt);

    this.an = "", this.Ta = "", this.Ra = void 0, this.Pa = null, this.hn = null, this.S = null, this.Fi = null, this.B = null, this.T = null, this.C = null, this.Cs = null, this.La = "", this.isInitialized = !1, this.Ua = !1, this.Wa = new u(), this.Va = new u(), this.options = {}, this.Fa = [], this.Ka = [], this.Mi = [], this.Ta = "5.9.0";
  }

  _createClass(Vt, [{
    key: "Ga",
    value: function Ga(t) {
      this.Wa.Dt(t);
    }
  }, {
    key: "Nh",
    value: function Nh(t) {
      this.Va.Dt(t);
    }
  }, {
    key: "initialize",
    value: function initialize(t, i) {
      var _this = this;

      if (this.nn()) return N.info("Braze has already been initialized with an API key."), !0;
      this.options = i || {};
      var e = this.ee(w.$h);
      var r = ll(no.$a());
      if (r && "true" === r.brazeLogging && (e = !0), N.init(e), N.info("Initialization Options: ".concat(JSON.stringify(this.options, null, 2))), null == t || "" === t || "string" != typeof t) return N.error("Braze requires a valid API key to be initialized."), !1;
      this.an = t;
      var n = this.ee(w.Zo);
      if (null == n || "" === n || "string" != typeof n) return N.error("Braze requires a valid baseUrl to be initialized."), !1;
      !1 === /^https?:/.test(n) && (n = "https://".concat(n));
      var o = n;
      if (n = document.createElement("a"), n.href = o, "/" === n.pathname && (n = "".concat(n, "api/v3")), this.La = n.toString(), ro.Ja && !this.ee(w.Yo)) return N.info("Ignoring activity from crawler bot " + navigator.userAgent), this.Ua = !0, !1;
      var h = this.ee(w.Wh) || !1;
      if (this.C = Bt.Ya(t, h), h && this.C.Ha(t), new ne.se(null, !0).gr(s.me)) return N.info("Ignoring all activity due to previous opt out"), this.Ua = !0, !1;

      var _iterator = _createForOfIteratorHelper(C(this.options)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t5 = _step.value;
          -1 === Rt(zt).indexOf(_t5) && N.warn("Ignoring unknown initialization option '".concat(_t5, "'."));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var a = ["mparticle", "wordpress", "tealium"];

      if (null != this.ee(w.Oa)) {
        var _t2 = this.ee(w.Oa);

        -1 !== a.indexOf(_t2) ? this.Ra = _t2 : N.error("Invalid sdk flavor passed: " + _t2);
      }

      var l = this.ee(zt.Vh);
      if (null != l) if (z(l)) {
        var _t3 = [];

        for (var _i = 0; _i < l.length; _i++) {
          ta(DeviceProperties, l[_i], "devicePropertyAllowlist contained an invalid value.", "DeviceProperties") && _t3.push(l[_i]);
        }

        l = _t3;
      } else N.error("devicePropertyAllowlist must be an array. Defaulting to all properties."), l = null;
      var c = this.ee(w.Na);

      if (c) {
        var _t4 = new _t(c);

        this.C.uu(s.iu.Na, _t4);
      }

      this.hn = new Ot(this.C, l), this.B = new Mt(this.C), this.Cs = new kt(this.B, this.C), this.T = new Wt(this.C, this.Cs, this.B, this.ee(w.Zh));
      var f = new u();
      return this.Pa = new qt(this.C, this.ee(w.Yh), f), this.F(f), this.S = new Pt(this.hn, this.C, this.Pa, this.Cs, this.T, this.B, this.an, this.La, this.Ta, this.Ra || "", this.ee(w.Qh), this.ee(w.Ea)), this.Fi = new Lt(this.an, this.La, this.T, this.hn, this.Cs, this.B, this.C, function (t) {
        if (_this.nn()) {
          var _iterator2 = _createForOfIteratorHelper(_this.ar()),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _i2 = _step2.value;

              _i2.U(t);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }, this.Pa, this.S), this.Fi.initialize(), h || this.C.Xa(), N.info("Initialized for the Braze backend at \"".concat(this.ee(w.Zo), "\" with API key \"").concat(this.an, "\".")), ot.p(), this.B.Ke(function () {
        var t;
        _this.isInitialized && (null === (t = _this.B) || void 0 === t ? void 0 : t.ke()) && import("../FeatureFlags/refresh-feature-flags.js").then(function (t) {
          if (!_this.isInitialized) return;
          (0, t.default)();
        });
      }), this.Fi.on(function () {
        var t;
        _this.isInitialized && (null === (t = _this.B) || void 0 === t ? void 0 : t.ke()) && import("../FeatureFlags/refresh-feature-flags.js").then(function (t) {
          if (!_this.isInitialized) return;
          (0, t.default)(void 0, void 0, !0);
        });
      }), this.Wa.X(this.options), this.isInitialized = !0, window.dispatchEvent(new CustomEvent("braze.initialized")), !0;
    }
  }, {
    key: "destroy",
    value: function destroy(t) {
      if (N.destroy(), this.nn()) {
        this.Va.X(), this.Va.removeAllSubscriptions();

        var _iterator3 = _createForOfIteratorHelper(this.Fa),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _t6 = _step3.value;

            _t6.destroy();
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        this.Fa = [];

        var _iterator4 = _createForOfIteratorHelper(this.Ka),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _t7 = _step4.value;

            _t7.clearData(!1);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        this.S && this.S.fo(), this.Ka = [], this.removeAllSubscriptions(), this.Mi = [], null != this.Fi && this.Fi.destroy(), this.Fi = null, this.Pa = null, this.hn = null, this.S = null, this.B = null, this.T = null, this.Cs = null, this.options = {}, this.Ra = void 0, this.isInitialized = !1, this.Ua = !1, t && (this.C = null);
      }
    }
  }, {
    key: "rr",
    value: function rr() {
      return !this.Za() && (!!this.nn() || (console.warn(p), !1));
    }
  }, {
    key: "Ma",
    value: function Ma() {
      return this.an;
    }
  }, {
    key: "Sr",
    value: function Sr() {
      return this.Pa;
    }
  }, {
    key: "Z",
    value: function Z() {
      return this.La;
    }
  }, {
    key: "ue",
    value: function ue() {
      return this.hn;
    }
  }, {
    key: "g",
    value: function g() {
      return this.S;
    }
  }, {
    key: "ee",
    value: function ee(t) {
      return this.options[t];
    }
  }, {
    key: "ar",
    value: function ar() {
      return this.Ka;
    }
  }, {
    key: "rn",
    value: function rn() {
      return this.Fi;
    }
  }, {
    key: "v",
    value: function v() {
      return this.B;
    }
  }, {
    key: "P",
    value: function P() {
      return this.T;
    }
  }, {
    key: "j",
    value: function j() {
      return this.C;
    }
  }, {
    key: "mr",
    value: function mr() {
      if (this.Cs && this.Fi) return new User(this.Cs, this.Fi);
    }
  }, {
    key: "ir",
    value: function ir() {
      return this.Cs;
    }
  }, {
    key: "tr",
    value: function tr() {
      return !0 === this.ee(w.re);
    }
  }, {
    key: "h",
    value: function h(t) {
      var i = !1;

      var _iterator5 = _createForOfIteratorHelper(this.Fa),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _s = _step5.value;
          _s === t && (i = !0);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      i || this.Fa.push(t);
    }
  }, {
    key: "_",
    value: function _(i) {
      var s = !1;

      var _iterator6 = _createForOfIteratorHelper(this.Ka),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _t8 = _step6.value;
          _t8.constructor === i.constructor && (s = !0);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      i instanceof t && !s && this.Ka.push(i);
    }
  }, {
    key: "F",
    value: function F(t) {
      t instanceof u && this.Mi.push(t);
    }
  }, {
    key: "removeAllSubscriptions",
    value: function removeAllSubscriptions() {
      if (this.rr()) {
        var _iterator7 = _createForOfIteratorHelper(this.Mi),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _t9 = _step7.value;

            _t9.removeAllSubscriptions();
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }
    }
  }, {
    key: "removeSubscription",
    value: function removeSubscription(t) {
      if (this.rr()) {
        var _iterator8 = _createForOfIteratorHelper(this.Mi),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var i = _step8.value;
            i.removeSubscription(t);
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }
    }
  }, {
    key: "fe",
    value: function fe(t) {
      this.Ua = t;
    }
  }, {
    key: "nn",
    value: function nn() {
      return this.isInitialized;
    }
  }, {
    key: "Za",
    value: function Za() {
      return this.Ua;
    }
  }, {
    key: "fi",
    value: function fi() {
      return this.Ta;
    }
  }]);

  return Vt;
}();

var r = new Vt();
export { r as default, Vt as BrazeSdkInstance, w as OPTIONS };